import script from "./nps.vue?vue&type=script&setup=true&lang=js"
export * from "./nps.vue?vue&type=script&setup=true&lang=js"

import "./nps.vue?vue&type=style&index=0&id=576f7f9e&scoped=true&lang=css"

import exportComponent from "/var/www/html/koboeat/test/customer_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-576f7f9e"]])

export default __exports__